module.exports = __webpack_public_path__ + "img/soleil@2x.eb34da5.jpg";